import { render } from "./invalid-records-overview.vue?vue&type=template&id=6eae830a&ts=true"
import script from "./invalid-records-overview.ts?vue&type=script&lang=ts&external"
export * from "./invalid-records-overview.ts?vue&type=script&lang=ts&external"

import "./invalid-records-overview.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__